(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-schools"]) return;
  try {
    
  if (!window.kiddilSchoolQuoteFormBound) {
    window.kiddilSchoolQuoteFormBound = true;

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-school-quote-form]');
      if (!form) return;

      event.preventDefault();

      const lines = [form.dataset.messageIntro];
      form.querySelectorAll('[data-message-label]').forEach((field) => {
        const value = field.value.trim();
        if (value) lines.push(`${field.dataset.messageLabel}: ${value}`);
      });
      if (form.dataset.sourceUrl) lines.push(`${form.dataset.sourceLabel}: ${form.dataset.sourceUrl}`);
      lines.push(form.dataset.messageFollowup);

      const message = encodeURIComponent(lines.join('\n'));
      const whatsappUrl = `https://wa.me/${form.dataset.whatsappNumber}?text=${message}`;
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
